function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// if(getParameterByName('edit')) {
//   localStorage.setItem('variants', getParameterByName('variants'));
//   localStorage.setItem('message', getParameterByName('message'));
// }

class CustomBox extends HTMLElement {
  constructor() {
    super();
    
    this.handle = this.dataset.handle;
    // header
    this.header = this.querySelector('.custom-box__header');
    this.headerImage = this.header.querySelector('img');
    this.headerTitle = this.header.querySelector('.header__title');
    this.headerSubtitle = this.header.querySelector('.header__subtitle');

    // Steps
    this.stepsLi = this.querySelectorAll('.custom-box__steps ul li');
    this.stepTitle = this.querySelector('.custom-box__step-title');
    this.step1Container = this.querySelector('.custom-box__step-1');
    this.step1Grid = this.step1Container.querySelector('.custom-box__step-1 .grid');
    this.step2Container = this.querySelector('.custom-box__step-2');
    this.step3Container = this.querySelector('.custom-box__step-3');
    this.step3Grid = this.step3Container.querySelector('.grid');
    this.step4Container = this.querySelector('.custom-box__step-4');
    this.step4Grid = this.step4Container.querySelector('.grid');
    this.step5Container = this.querySelector('.custom-box__step-5');

    // Messages
    this.messageField = this.querySelector('#cmMsgInput');
    this.messages = this.querySelectorAll('.predefined-messages input[type="radio"]');    

    this.messageField.addEventListener('keyup', function(){
      this.handleMessageCharacters();      
    }.bind(this));

    // Rendering all the steps
    this.renderStep1Content(this.handle);

    window.addEventListener('load', function(){
      this.renderStep2Content(this.handle);
      this.renderStep3Content(this.handle);
      this.renderStep4Content(this.handle);
    }.bind(this));

    this.step1Container.querySelector('.custom-box__nav-next').addEventListener('click', function(e){
      e.preventDefault();
      this.step1Container.classList.add('hidden');
      this.step2Container.classList.remove('hidden');
      this.stepsLi[1].classList.add('active');
      this.setAttribute('data-current-step', 2);
      this.stepTitle.textContent = this.step2Container.dataset.subtitle;
      // this.renderStep2Content(this.handle);
      this.scrollToTop();
    }.bind(this));

    this.step2Container.querySelector('.custom-box__nav-next').addEventListener('click', function(e){
      e.preventDefault();
      this.step2Container.classList.add('hidden');
      this.step3Container.classList.remove('hidden');
      this.stepsLi[2].classList.add('active');
      this.setAttribute('data-current-step', 3);
      this.stepTitle.textContent = this.step3Container.dataset.subtitle;
      // this.renderStep3Content(this.handle);
      this.scrollToTop();
    }.bind(this));

    this.step3Container.querySelector('.custom-box__nav-next').addEventListener('click', function(e){
      e.preventDefault();
      this.step3Container.classList.add('hidden');
      this.step4Container.classList.remove('hidden');
      this.stepsLi[3].classList.add('active');
      this.setAttribute('data-current-step', 4);
      this.stepTitle.textContent = this.step4Container.dataset.subtitle;
      // this.renderStep4Content(this.handle);
      this.scrollToTop();
    }.bind(this));

    this.step4Container.querySelector('.custom-box__nav-next').addEventListener('click', function(e){
      e.preventDefault();
      this.step4Container.classList.add('hidden');
      this.step5Container.classList.remove('hidden');
      // this.stepsLi[4].classList.add('active');
      this.setAttribute('data-current-step', 5);
      this.scrollToTop();
    }.bind(this));

    this.step2Container.querySelector('.custom-box__nav-prev').addEventListener('click', function(e){
      e.preventDefault();
      this.step1Container.classList.remove('hidden');
      this.step2Container.classList.add('hidden');
      this.stepsLi[1].classList.remove('active');
      this.setAttribute('data-current-step', 1);
      this.stepTitle.textContent = this.step1Container.dataset.subtitle;
      this.scrollToTop();
    }.bind(this));

    this.step3Container.querySelector('.custom-box__nav-prev').addEventListener('click', function(e){
      e.preventDefault();
      this.step2Container.classList.remove('hidden');
      this.step3Container.classList.add('hidden');
      this.stepsLi[2].classList.remove('active');
      this.setAttribute('data-current-step', 2);
      this.stepTitle.textContent = this.step2Container.dataset.subtitle;
      this.scrollToTop();
    }.bind(this));

    this.step4Container.querySelector('.custom-box__nav-prev').addEventListener('click', function(e){
      e.preventDefault();
      this.step3Container.classList.remove('hidden');
      this.step4Container.classList.add('hidden');
      this.stepsLi[3].classList.remove('active');
      this.setAttribute('data-current-step', 3);
      this.stepTitle.textContent = this.step3Container.dataset.subtitle;
      this.scrollToTop();
    }.bind(this));

    this.step5Container.querySelector('.custom-box__nav-prev').addEventListener('click', function(e){
      e.preventDefault();
      this.step4Container.classList.remove('hidden');
      this.step5Container.classList.add('hidden');
      this.setAttribute('data-current-step', 4);
      this.stepTitle.textContent = this.step4Container.dataset.subtitle;
      this.scrollToTop();
    }.bind(this));

    this.querySelector('.custom-box__nav-atc').addEventListener('click', function(){
      if(getParameterByName('ts')) {
        document.body.classList.add('data-loading');
        let formData = {updates: {}};
        document.querySelectorAll('.cart-item[data-item-ts="'+ getParameterByName('ts') +'"]').forEach(function(el, index){
          formData.updates[el.getAttribute('id').replace('cart-notification-product-', '')] = 0;
        });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            this.createBox();
          }).catch((e) => {
            console.error(e);
          });
      } else {
        this.createBox();
      }      
    }.bind(this));

    // this.addEventListener('change', function(e){
    //   // alert('changed');
    //   e.preventDefault();
    //   let el = e.target;
    //   this.changeEvent(el);
    // });

    this.addEventListener('click', function(e){
      // alert('clicked');
      
      let el = e.target;
      // if(el.type === 'checkbox') return;
      if(el.closest('summary') !== null) {
        e.preventDefault();
        let details = el.closest('details');
        if(details.open) {
          details.removeAttribute('open')
        } else {
          details.setAttribute('open', true);
        }        
      }else if(el.name === 'preselected_message') {
        this.changeEvent(el);
      }else if(el.classList.contains('quick__view')) {   
        e.preventDefault();     
        document.body.classList.add('no-overflow');
        let parent = el.closest('.custom-box__card');
        parent.querySelector('.custom-box__quick-view .quantity__input').value = parent.querySelector('input[type="checkbox"]').dataset.quantity;
        parent.querySelector('.custom-box__quick-view').classList.remove('hidden');
      }else if(el.classList.contains('qv__button')) {
        let parent = el.closest('.custom-box__card');
        let inputSelector = parent.querySelector('input[type="checkbox"]');
        inputSelector.setAttribute('data-quantity', parent.querySelector('input.quantity__input').value);
        inputSelector.checked = true;
        this.changeEvent(inputSelector);
        parent.querySelector('.custom-box__quick-view').classList.add('hidden');
        document.body.classList.remove('no-overflow');
      }else if(el.classList.contains('qv__close')) {
        let parent = el.closest('.custom-box__card');
        parent.querySelector('.custom-box__quick-view').classList.add('hidden');
        document.body.classList.remove('no-overflow');
      }else if(el.closest('.custom-box__quick-view') !== null){
      }else if(el.closest('.custom-box__card') !== null) {
        let card = el.closest('.custom-box__card');
        card.classList.toggle('selected');
        if(!card.querySelector('input').checked) {
          card.querySelector('input').checked = true;  
        } else {
          card.querySelector('input').checked = false; 
        }
        this.changeEvent(card.querySelector('input'));   
      }
    })
  }

  scrollToTop() {
    window.scrollTo({
      top: document.querySelector('custom-box').offsetTop,
      left: 0
    })
  }

  changeEvent(el) {
    if(el.type === 'checkbox'){
      let parent = el.closest(".custom-box__step");
      let allEls = parent.querySelectorAll(".custom-box__card input[type='checkbox']");
      let next = parent.querySelector(".custom-box__nav-next");
      let prev = parent.querySelector(".custom-box__nav-prev");
      let minLimit = parseInt(parent.dataset.minQty);
      let maxLimit = parseInt(parent.dataset.maxQty);

      if(parent.querySelectorAll("input[type='checkbox']:checked").length === maxLimit) {
        allEls.forEach((input, index) => {
          if(!input.checked) {
            input.closest(".custom-box__card").classList.add('disabled');
          }
        });          
      } else {
        allEls.forEach((input, index) => {
          input.closest(".custom-box__card").classList.remove('disabled');
        });          
      }

      if(next) {
        if(parent.querySelectorAll("input[type='checkbox']:checked").length >= minLimit) {
          next.classList.remove('disabled');
        } else {
          next.classList.add('disabled');
        }
      }
    }

    // Selecting a pre-written message
    if(el.name === 'preselected_message') {
      this.messageField.value = el.value;
      el.closest('details').removeAttribute('open');
      this.handleMessageCharacters();
    }
  }

  editBoxActions(parent) {
    if(getParameterByName('edit')) {
      let variants = JSON.parse(getParameterByName('variants'));
      let quantities = JSON.parse(getParameterByName('quantity'));
      let message = JSON.parse(getParameterByName('message'));
      let details = JSON.parse(getParameterByName('details'));
      variants.forEach((element, i) => {
        let parentContainer = document.querySelector(`[data-collection-title="${details[i].title.trim()}"]`);
        if(!parentContainer) return;
        let targetEl = parentContainer.querySelector('input[type="checkbox"][value="'+ element +'"]');    
        if(targetEl) {
          targetEl.checked = true;
          targetEl.dataset.quantity = quantities[i];
          this.changeEvent(targetEl);
        }
      });

      if(message) {
        document.getElementById('recipientInput').value = message['To'];
        document.getElementById('userNameInput').value = message['From'];
        document.getElementById('cmMsgInput').value = message['Message'];
      }
      // window.history.pushState({}, document.title, location.origin + location.pathname);
    }    
  }

  handleMessageCharacters() {
    let limit = 300;
    let length = this.messageField.value.length;
    
    if((limit - length) <= 0) {
      document.querySelector('#characters').style.color = "red";
      document.querySelector('#characters span').textContent = 0;
    }else {
      document.querySelector('#characters').removeAttribute('style');
      document.querySelector('#characters span').textContent = limit - length;
    }
  }

  renderProductCard(data, type){
    let li = document.createElement('li');
    li.innerHTML = `<input type="checkbox" name="${type}" value="${data.variant_id}" tabindex="${i++}" data-quantity="1" id="item-${data.variant_id}-${type}" data-product-price="${data.product_price}" data-product-title="${data.tittle}" />
    <label for="items-${data.variant_id}-${type}">
      <div class="icons">
        ${document.getElementById('icon-plus-2').innerHTML}
        ${document.getElementById('icon-check').innerHTML}
      </div>            
      <div class="media" style="padding-bottom: 100%;">
        <img src="${data.src.replace('.jpg', '_180x.jpg').replace('.png', '_180x.png')}" alt="${data.tittle}" />
        <div class="price ${data.product_price <= 0 ? 'hidden' : ''}">₹${data.product_price}</div>
      </div>
      <div class="content">
        <h4>${data.tittle}</h4>
        <a href="/products/${data.handle}" class="quick__view ${data.product_price <= 0 ? 'hidden' : ''}">${document.getElementById('icon-quick-view').innerHTML}</a>     
      </div>      
    </label>
    <div class="custom-box__quick-view hidden">
    <span class="qv__close qv__overlay"></span><div class="qv__grid">
      <span class="qv__close qv__close-icon"></span>
      <div class="qv__grid-item">
      <img src="${data.src.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png')}" alt="${data.tittle}" />
      </div>
      <div class="qv__grid-item">
        <product-title>${data.tittle}</product-title>
        <div class="qv__qty">
          <label>Quantity</label>
          <quantity-input class="quantity">
            <button class="quantity__button no-js-hidden" name="minus" type="button">                
              -
            </button>
            <input class="quantity__input"
                type="number"
                name="quantity"
                min="1"
                value="1"
              >
            <button class="quantity__button no-js-hidden" name="plus" type="button">
              +
            </button>
          </quantity-input>
        </div>
        <button class="button button--primary qv__button">Add To Cart</button>
      </div>
      </div>
    </div>
    `
    li.setAttribute('data-product-handle', data.handle);
    li.setAttribute('data-product-sku', data.sku);
    li.classList.add('grid__item', 'custom-box__card');
    if (typeof data.tags === 'string' && data.tags.includes('product-delhi')) {
      li.classList.add('hide-unless-delhi');
    }
    return li;
  }

  renderStep1Content(handle) {
    fetch(`https://poojastore.mobikasa.net/api/get/get_box/${handle}/step1`)
      .then((response)  => {
        return response.json();
      })
      .then((data) => {
        const d = data.data;
        const products = d[0][0].products;
        let thisParentContainer = this.step1Container;

        this.headerImage.src = d.banner_image;
        this.headerTitle.textContent = d.box_subtitle;
        this.headerSubtitle.textContent = d.box_title;     
        
        document.querySelector('[name="properties[_topTitle]"]').value = d.box_title;

        this.stepTitle.textContent = d.collection_subtitle;
        thisParentContainer.setAttribute('data-subtitle', d.collection_subtitle);
        thisParentContainer.setAttribute('data-min-qty', d.min_qty);
        thisParentContainer.setAttribute('data-max-qty', d.max_qty);

        // enable Next button is the minimum quanity is 0 i.e Skip option
        if(d.min_qty === 0) {
          thisParentContainer.querySelector('.custom-box__nav-next').classList.remove('disabled');
        }

        // build predefined messages
        for(var i=0;i<d.custom_message.length;i++) {
          let message = document.createElement('li');
          message.innerHTML = `<input type="radio" value="${d.custom_message[i]}" name="preselected_message" id="key-${i}" /><label for="key-${i}">${d.custom_message[i]}</label>`;
          document.querySelector('.predefined-messages ul').append(message);
        }

        // build step 1 grid
        for(var i=0; i<products.length;i++) { 
          this.step1Grid.setAttribute('data-collection-title', d[0][0].collection_name);         
          this.step1Grid.append(this.renderProductCard(products[i], 'collection-1'));
        }
        
        thisParentContainer.classList.add('content-loaded');
        this.editBoxActions(thisParentContainer);
      })
      .catch((error) => {
        throw error;
      })
  }

  renderStep2Content(handle) {
    let thisParentContainer = this.step2Container;
    if(thisParentContainer.classList.contains('content-loaded')) {return;}
    fetch(`https://poojastore.mobikasa.net/api/get/get_box/${handle}/step2`)
      .then((response)  => {
        return response.json();
      })
      .then((data) => {
        const d = data.data;
        const collections = d[0];        

        // this.stepTitle.textContent = d.collection_subtitle;
        thisParentContainer.setAttribute('data-subtitle', d.collection_subtitle);   
        thisParentContainer.setAttribute('data-min-qty', d.min_qty);
        thisParentContainer.setAttribute('data-max-qty', d.max_qty);     

        // enable Next button is the minimum quanity is 0 i.e Skip option
        if(d.min_qty === 0) {
          thisParentContainer.querySelector('.custom-box__nav-next').classList.remove('disabled');
        }

        // build step 2 collection accordians
        for (var i=0;i<collections.length;i++) {
          let collection = collections[i];
          let products = collection.products;          
          let div = document.createElement('div');
          div.classList.add('collection__list');
          if(collections.length > 1) {
          div.innerHTML = `<details ${collection.collection_image === '' ? 'open': ''}>
            <summary ${collection.collection_image === '' ? 'hidden': ''}>
              <img src="${collection.collection_image}" alt="${collection.collection_name}" />
              <h3>
                ${collection.collection_name}
                ${document.getElementById('icon-chevron').innerHTML}
              </h3>
            </summary>
            <ul class="grid grid--2-col grid--4-col-tablet grid--6-col-desktop" data-collection-title="${collection.collection_name}"></ul>
          </details>`;
          } else {
            div.innerHTML = `<ul class="grid grid--2-col grid--4-col-tablet grid--6-col-desktop" data-collection-title="${collection.collection_name}"></ul>`;
          }
          for(var j=0; j<products.length;j++) {
            div.querySelector('.grid').append(this.renderProductCard(products[j], 'collection-2'));
          }
          thisParentContainer.append(div);          
        }
        thisParentContainer.classList.add('content-loaded');
        this.editBoxActions(thisParentContainer);
      })
      .catch((error) => {
        throw error;
      })
  }

  renderStep3Content(handle) {
    let thisParentContainer = this.step3Container;
    if(thisParentContainer.classList.contains('content-loaded')) {return;}
    fetch(`https://poojastore.mobikasa.net/api/get/get_box/${handle}/step3`)
      .then((response)  => {
        return response.json();
      })
      .then((data) => {
        const d = data.data;
        const products = d[0][0].products;        

        // this.stepTitle.textContent = d.collection_subtitle;
        thisParentContainer.setAttribute('data-subtitle', d.collection_subtitle);
        thisParentContainer.setAttribute('data-min-qty', d.min_qty);
        thisParentContainer.setAttribute('data-max-qty', d.max_qty); 

        // enable Next button is the minimum quanity is 0 i.e Skip option
        if(d.min_qty === 0) {
          thisParentContainer.querySelector('.custom-box__nav-next').classList.remove('disabled');
        }

        // build step 3 grid
        for(var i=0; i<products.length;i++) {    
          this.step3Grid.setAttribute('data-collection-title', d[0][0].collection_name);      
          this.step3Grid.append(this.renderProductCard(products[i], 'collection-3'));
        }
        thisParentContainer.classList.add('content-loaded');
        this.editBoxActions(thisParentContainer);
      })
      .catch((error) => {
        throw error;
      })
  }

  renderStep4Content(handle) {
    let thisParentContainer = this.step4Container;
    if(thisParentContainer.classList.contains('content-loaded')) {return;}
    fetch(`https://poojastore.mobikasa.net/api/get/get_box/${handle}/step4`)
      .then((response)  => {
        return response.json();
      })
      .then((data) => {
        const d = data.data;
        const products = d[0][0].products;        

        // this.stepTitle.textContent = d.collection_subtitle;
        thisParentContainer.setAttribute('data-subtitle', d.collection_subtitle);
        thisParentContainer.setAttribute('data-min-qty', d.min_qty);
        thisParentContainer.setAttribute('data-max-qty', d.max_qty); 

        // enable Next button is the minimum quanity is 0 i.e Skip option
        if(d.min_qty === 0) {          
          thisParentContainer.querySelector('.custom-box__nav-next').classList.remove('disabled');
        }

        // build step 4 grid
        for(var i=0; i<products.length;i++) { 
          this.step4Grid.setAttribute('data-collection-title', d[0][0].collection_name);         
          this.step4Grid.append(this.renderProductCard(products[i], 'collection-3'));
        }
        thisParentContainer.classList.add('content-loaded');
        this.editBoxActions(thisParentContainer);
      })
      .catch((error) => {
        throw error;
      })
  }

  createBox() {    
    document.body.classList.add('data-loading');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    let formData = {'items': []};
    let totalPrice = 0;
    let variants = [];
    let quantity = [];
    let productDetails = [];
    let timestamp = (new Date().getTime());
    let message = {
      To: document.getElementById('recipientInput').value.toUpperCase(),
      From: document.getElementById('userNameInput').value.toUpperCase(),
      Message: document.getElementById('cmMsgInput').value
    }

    this.querySelectorAll('.custom-box__card input:checked').forEach((el, index) => {
      variants.push(el.value);
      quantity.push(el.dataset.quantity);
      totalPrice += (parseInt(el.dataset.productPrice)*el.dataset.quantity);
      if(el.closest('ul.grid').dataset.collectionTitle) {
        productDetails.push({
          title: el.closest('ul.grid').dataset.collectionTitle,
          name: el.dataset.productTitle,
          price: '₹' + parseInt(el.dataset.productPrice).toLocaleString('en-IN'),
          qty: el.dataset.quantity
        })
      }
    });

    this.querySelectorAll('.custom-box__card input:checked').forEach((el, index) => {      
      formData.items.push({
        id: el.value,
        quantity: el.dataset.quantity,
        properties: {
          '_ts': timestamp,
          'Box Id': timestamp,
          '_topTitle': document.querySelector('[name="properties[_topTitle]"]').value,
          '_variants': JSON.stringify(variants),
          '_quantity': JSON.stringify(quantity),
          '_message': JSON.stringify(message),
          '_totalPrice': ('₹' + totalPrice.toLocaleString('en-IN')),
          '_productDetails': JSON.stringify(productDetails),
          '_url': window.location.pathname
        }
      });
      formData.items[index].properties[document.querySelector('.custom-box__header .header__subtitle').textContent +' ID'] = timestamp
    });

    formData.items.reverse();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then((response) => {
      document.getElementById('recipientInput').value = '';
      document.getElementById('userNameInput').value = '';
      document.getElementById('cmMsgInput').value = '';
      location.href = "/cart";
    })
    .catch((e) => {
      console.error(e);
      document.body.classList.remove('data-loading');
      alert('ERROR: Please try again after some time.');
    })
    .finally(() => {
      // console.log('finally');
    });
  }
}

customElements.define('custom-box', CustomBox);